import { Spinner } from '@frontend/components/common';
import { FormattedMessage, useIntl } from 'react-intl';

import KioskRadioButton from '../../../components/kiosk-radio-button/kiosk-radio-button.component';
import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import useConfirmCurrentDeviceLocation from './confirm-current-device-location.controller';

const ID = 'confirm-current-device-location';

const ConfirmCurrentDeviceLocation = () => {
    const intl = useIntl();
    const viewProps = useConfirmCurrentDeviceLocation();

    if (viewProps.isLoading) {
        return (
            <WizardScreenContainer id={ID}>
                <div className='flex size-full items-center justify-center'>
                    <Spinner className='text-border-default fill-brand-primary size-12' />
                </div>
            </WizardScreenContainer>
        );
    }

    return (
        <WizardScreenContainer
            loadingModal={{
                show: viewProps.isLoading
            }}
            footer={{
                onSubmit: viewProps.onSubmit,
                submitDisabled: viewProps.selectedOption === null || viewProps.noOptionsAvailable
            }}
            id={ID}>
            <div className='text-always-black w-full text-base font-medium'>
                <FormattedMessage
                    id='kiosk.wizard.confirm-current-location.instructions'
                    defaultMessage='Select location'
                />
            </div>

            {viewProps.noOptionsAvailable ? (
                <div className='bg-background-surface text-always-black w-full rounded-xl p-4 text-base font-medium'>
                    <FormattedMessage
                        id='kiosk.wizard.confirm-current-location.no-options-available'
                        defaultMessage='Your current packages cannot be handled at this location.'
                    />
                </div>
            ) : (
                <div className='flex flex-col items-start justify-start gap-2 self-stretch'>
                    <KioskRadioButton
                        disabled={!viewProps.optionBEnabled}
                        subtext={intl.formatMessage({
                            id: 'kiosk.wizard.confirm-current-location.use-current-location',
                            defaultMessage: 'Use your current location'
                        })}
                        text={viewProps.currentSpot?.name ?? ''}
                        onClick={() => viewProps.setSelectedOption('B')}
                        selected={viewProps.selectedOption === 'B'}
                    />
                    <KioskRadioButton
                        disabled={!viewProps.optionAEnabled}
                        subtext={intl.formatMessage({
                            id: 'kiosk.wizard.confirm-current-location.continue-destination',
                            defaultMessage: 'Continue to original destination'
                        })}
                        text={viewProps.destinationSpot?.name ?? ''}
                        onClick={() => viewProps.setSelectedOption('A')}
                        selected={viewProps.selectedOption === 'A'}
                    />
                </div>
            )}
        </WizardScreenContainer>
    );
};

export default ConfirmCurrentDeviceLocation;
